import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import "./AdministratorSidebar.css";
import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap for responsive design

const AdministratorSidebar = () => {
  const [isSidebarActive, setIsSidebarActive] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const [userFullName, setUserFullName] = useState("");

  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarActive(!isSidebarActive);
  };

  // Toggle submenu and close others
  const toggleSubmenu = (submenu) => {
    setOpenSubmenu(openSubmenu === submenu ? null : submenu);
  };

  // Load user full name from localStorage on mount
  useEffect(() => {
    const storedFName = localStorage.getItem("fname");
    const storedLName = localStorage.getItem("lname");
    if (storedFName && storedLName) {
      setUserFullName(`${storedFName} ${storedLName}`);
    } else if (storedFName) {
      setUserFullName(storedFName);
    } else {
      setUserFullName(localStorage.getItem("userName") || "Administrator");
    }
  }, []);

  return (
    <div className="wrapper">
      {/* Sidebar Toggle Button for Mobile */}
      <button
        type="button"
        id="sidebarCollapse"
        className="btn btn-info d-md-none"
        onClick={toggleSidebar}
      >
        <i className="fas fa-bars"></i>
      </button>

      {/* Sidebar */}
      <nav id="sidebar" className={isSidebarActive ? "active" : ""}>
        <div className="sidebar-header">
          <h3 className="sidebar-title">Administrator Panel</h3>
        </div>

        <ul className="list-unstyled components">
          <li>
            <Link to="/admin-panel" className="nav-link">
              <i className="fas fa-tachometer-alt"></i> Dashboard
            </Link>
          </li>

          <li className={openSubmenu === "vehicles" ? "active" : ""}>
            <a
              href="#vehiclesSubmenu"
              className="nav-link dropdown-toggle"
              onClick={() => toggleSubmenu("vehicles")}
            >
              <i className="fas fa-car"></i> Vehicles Details
            </a>
            {openSubmenu === "vehicles" && (
              <ul className="list-unstyled">
                <li>
                  <Link to="/vehicles" className="nav-link">
                    View Vehicle List
                  </Link>
                </li>
                <li>
                  <Link to="/add-vehicle" className="nav-link">
                    Add New Vehicle
                  </Link>
                </li>
                <li>
                  <Link to="/vehicles-cost" className="nav-link">
                    Vehicle Cost
                  </Link>
                </li>
              </ul>
            )}
          </li>

          <li className={openSubmenu === "sales" ? "active" : ""}>
            <a
              href="#salesSubmenu"
              className="nav-link dropdown-toggle"
              onClick={() => toggleSubmenu("sales")}
            >
              <i className="fas fa-dollar-sign"></i> Sales Details
            </a>
            {openSubmenu === "sales" && (
              <ul className="list-unstyled">
                <li>
                  <Link to="/view-sales" className="nav-link">
                    View All Sales
                  </Link>
                </li>
                <li>
                  <Link to="/add-new-sale" className="nav-link">
                    Create New Sale
                  </Link>
                </li>
              </ul>
            )}
          </li>

          <li className={openSubmenu === "docs" ? "active" : ""}>
            <a
              href="#docsSubmenu"
              className="nav-link dropdown-toggle"
              onClick={() => toggleSubmenu("docs")}
            >
              <i className="fas fa-file-alt"></i> Documents & Shipping
            </a>
            {openSubmenu === "docs" && (
              <ul className="list-unstyled">
                <li>
                  <Link to="/documents-shipping" className="nav-link">
                    Documents/Shipping
                  </Link>
                </li>
              </ul>
            )}
          </li>

          <li className={openSubmenu === "payments" ? "active" : ""}>
            <a
              href="#paymentsSubmenu"
              className="nav-link dropdown-toggle"
              onClick={() => toggleSubmenu("payments")}
            >
              <i className="fas fa-wallet"></i> Payments
            </a>
            {openSubmenu === "payments" && (
              <ul className="list-unstyled">
                <li>
                  <Link to="/volet" className="nav-link">
                    View Wallet
                  </Link>
                </li>
                <li>
                  <Link to="/create-volet" className="nav-link">
                    Receive Wallet Amount
                  </Link>
                </li>
                <li>
                  <Link to="/view-payments" className="nav-link">
                    View Allocated Payments
                  </Link>
                </li>
                <li>
                  <Link to="/create-allocate" className="nav-link">
                    Add Allocated Amount
                  </Link>
                </li>
              </ul>
            )}
          </li>

          <li>
            <Link to="/accounts" className="nav-link">
              <i className="fas fa-users"></i> Accounts
            </Link>
          </li>

          <li>
            <Link to="/portfolio" className="nav-link">
              <i className="fas fa-briefcase"></i> Portfolio
            </Link>
          </li>

          <li className={openSubmenu === "settings" ? "active" : ""}>
            <a
              href="#settingsSubmenu"
              className="nav-link dropdown-toggle"
              onClick={() => toggleSubmenu("settings")}
            >
              <i className="fas fa-cog"></i> Settings
            </a>
            {openSubmenu === "settings" && (
              <ul className="list-unstyled">
                <li>
                  <NavLink to="/view-user" className="nav-link">
                    All Users
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/create-account" className="nav-link">
                    Create Account
                  </NavLink>
                </li>
              </ul>
            )}
          </li>
        </ul>
      </nav>

      {/* Overlay for mobile when sidebar is active */}
      {isSidebarActive && <div className="overlay" onClick={toggleSidebar}></div>}
    </div>
  );
};

export default AdministratorSidebar;